import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'roundMiles',
    standalone: false,
})
export class RoundMilesPipe implements PipeTransform {
    public transform(value: number): string {
        if (value === null || value === undefined) {
            return '';
        }
        const rounded = Math.round(value * 10) / 10; // nearest 0.1
        return `${rounded} mi`;
    }
}
